<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        props: {
            serviceName: {
                type: String,
                default: ()=>{ return '' },
            },
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/${this.entityTypeUrl()}/${this.$route.params.id}/promotions/${this.$route.params.promotion_id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/${this.entityTypeUrl()}/${this.$route.params.id}/promotions/${this.$route.params.promotion_id}/edit`
                    },
                    {
                        title: 'Клиенты',
                        url: `/${this.entityTypeUrl()}/${this.$route.params.id}/promotions/${this.$route.params.promotion_id}/clients`
                    },
                    {
                        title: 'Импорт',
                        url: `/${this.entityTypeUrl()}/${this.$route.params.id}/promotions/${this.$route.params.promotion_id}/import`
                    },
                ]
            }
        },
        methods: {
            entityTypeUrl() {
                if (this.$route.params.code) {
                    return `${this.serviceName}/${this.$route.params.code}`
                }
                return this.serviceName;
            }
        }
    }
</script>
